import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const CenterHeartIcon = (props: SvgProps) => (
  <Svg
    width={46}
    height={46}
    fill="none"
    {...props}
  >
    <Path
      stroke="#C0A46F"
      strokeLinecap="round"
      strokeWidth={2}
      d="M23.203 45c5.857-2.528 18.298-11.022 21.215-24.775C48.064 3.035 33.81-3.37 23.203 4.045c-10.607 7.416-4.806 29.326 7.624 35.562"
    />
    <Path
      stroke="#C0A46F"
      strokeLinecap="round"
      strokeWidth={2}
      d="M23.232 45C17.26 42.472 4.57 33.978 1.594 20.225c-3.72-17.19 10.82-23.595 21.638-16.18 10.82 7.416 4.903 29.326-7.776 35.562"
    />
  </Svg>
)
export default CenterHeartIcon
